import React from 'react'

export const BulkCheckinSelectionContext = React.createContext<{
  checkedCheckinIds: string[]
  addCheckedCheckinId: (id: string) => void
  removeCheckedCheckinId: (id: string) => void
  clearCheckedCheckinIds: () => void
}>({
  checkedCheckinIds: [],
  addCheckedCheckinId: () => {},
  removeCheckedCheckinId: () => {},
  clearCheckedCheckinIds: () => {},
})
